

export const S_URL = process.env.REACT_APP_STAG_URL

// export const INSTAGRAM_ACCESS_TOKEN = process.env.REACT_APP_INSTAGRAM_ACCESS_TOKEN;  INSTA changes
// export const INSTAGRAM_ID = process.env.REACT_APP_INSTAGRAM_ID;  INSTA changes

export const FADE_INTERVAL = 300;
export const ANIMATION_INTERVAL = 300;
export const DELAY_INTERVAL = 3000;
export const AFTER_POPUP_INTERVAL = 2100;
export const G_CLIENT_ID = "258206932309-68hmfr8t1rhiofd253blnrogu41o32vi.apps.googleusercontent.com";
export const FB_CLIENT_ID = "1692389344107335";
export const FB_APP_VERSION = "v2.7";
export const IS_GODMODE = false;
export const RED_EYE = "https://assets.graphia.in/site_media/webapp/red_eye.png";
export const BLACK_EYE = "https://assets.graphia.in/site_media/webapp/black_eye.png";
export const WHITE_EYE = "https://assets.graphia.in/site_media/webapp/white_eye.png";
export const MAX_DOWNLOAD_SIZE_IN_MOBILE = 262144000;
export const DASHBOARD = 'dashboard'
export const WORK_DETAILS = 'work_details'
export const GUEST_UPLOADS = 'guest_uploads'
export const ALBUM_SELECTION = 'album_selection'
export const SHARED_LINKS = 'shared_links'
export const QUOTE_FORM = 'quote_form'
export const REGISTER_SELFIE = 'register_selfie'
export const HOME_URL = 'home_url'
export const USER_FOLDERS = 'user_Folders'
export const BLACKLIST_REVIEW = 'blacklist_review'
export const USER_RATINGS = 'user_ratings'
export const ACTIVITY = 'activity'
export const MASKED_COST = '₹ ******'
export const IOS_MAX_BATCH_SIZE = 262144000
export const COMMENT_TIME_STEP = 1;

// EG-1599. `status` is a machine value; these are the words. "in progress"
// earns its own treatment because it means the couple started and stopped.
export const CREATIVE_PREFERENCE_STATES = {
    'not started': { meta: 'Pending', className: '' },
    'in progress': { meta: 'In progress', className: 'is-open' },
    submitted: { meta: 'Submitted', className: 'is-done' },
};

// EG-1641. The wedding day schedule reports its own status, on its own form.
export const WEDDING_DAY_STATES = {
    'not started': { meta: 'Pending', className: '' },
    'in progress': { meta: 'In progress', className: 'is-open' },
    submitted: { meta: 'Submitted', className: 'is-done' },
};
export const PAGINATION_BATCH_SIZE = 3
export const PAGE_REQUEST_TIMEOUT_MS = 30000
export const PAGE_RETRY_LIMIT = 1
export const PAGE_RETRY_DELAY_MS = 2000
export const GRID_RENDER_WINDOW = 1000
